module.exports = __webpack_public_path__ + "assets/img/undraw_subscribe_vspl.228b0b0c.svg";